import { apiGet, apiPost } from '../lib/apiClient';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

let cachedPublicKey = null;
let lastSubscribeAt = 0;

async function getVapidPublicKey() {
  if (process.env.REACT_APP_VAPID_PUBLIC_KEY) {
    return process.env.REACT_APP_VAPID_PUBLIC_KEY;
  }
  if (cachedPublicKey) return cachedPublicKey;
  try {
    const res = await apiGet('/push/vapid-public-key');
    cachedPublicKey = res?.publicKey || null;
    return cachedPublicKey;
  } catch {
    return null;
  }
}

/**
 * Daftarkan Web Push subscription ke server (muncul di perangkat meski tab ditutup).
 */
export const initPushNotifications = async ({ force = false } = {}) => {
  if (typeof window === 'undefined') return null;
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  if (Notification.permission !== 'granted') return null;

  // Hindari spam subscribe beruntun (kecuali force)
  const now = Date.now();
  if (!force && now - lastSubscribeAt < 15000) return null;

  const publicKey = await getVapidPublicKey();
  if (!publicKey) return null;

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();

    // Resubscribe jika belum ada
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    await apiPost('/push/subscribe', { subscription: subscription.toJSON() });
    lastSubscribeAt = now;
    return subscription;
  } catch (error) {
    console.warn('[pushNotifications] subscribe failed:', error);
    // Coba ulang: unsubscribe lokal lalu subscribe ulang
    try {
      const registration = await navigator.serviceWorker.ready;
      const old = await registration.pushManager.getSubscription();
      if (old) await old.unsubscribe();
      const fresh = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
      await apiPost('/push/subscribe', { subscription: fresh.toJSON() });
      lastSubscribeAt = Date.now();
      return fresh;
    } catch (retryErr) {
      console.warn('[pushNotifications] resubscribe failed:', retryErr);
      return null;
    }
  }
};
